export default __webpack_public_path__ + "static/media/4.5c540666.jpg";